export default __webpack_public_path__ + "static/media/stripe.c4f72bcf.svg";